import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';
const { GET_PATIENT_FAILURE, GET_PATIENT_REQUEST, GET_PATIENT_SUCCESS, GET_PATIENT_LOADING } =
  patientAction;

function* getPatientRecord(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_LOADING });
    const response = yield call(patientService.getPatientRecord, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_FAILURE, payload: error });
  }
}

function* getPatientRecordSaga() {
  yield takeEvery(GET_PATIENT_REQUEST, getPatientRecord);
}

export default getPatientRecordSaga;
